export const renderJobResponsibilities = (content) => {
  if (!content) return '';

  if (/<[a-z][\s\S]*>/i.test(content)) {
    return content;
  }

  const lines = content.split('\n');
  let html = '';
  let inList = false;

  for (let i = 0; i < lines.length; i++) {
    const line = lines[i];
    const trimmed = line.trim();

    if (!trimmed) {
      if (inList) {
        html += '</ul>';
        inList = false;
      }
      html += '<br/>';
      continue;
    }

    if (trimmed.startsWith('- ') || trimmed.startsWith('• ')) {
      if (!inList) {
        html += '<ul style="margin:4px 0;padding-left:20px;">';
        inList = true;
      }
      html += `<li>${trimmed.substring(2)}</li>`;
    } else {
      if (inList) {
        html += '</ul>';
        inList = false;
      }
      if (/^[A-Z][^.!?]*:$/.test(trimmed) || trimmed.endsWith(':')) {
        html += `<strong style="display:block;margin-top:8px;">${trimmed}</strong>`;
      } else {
        html += `<span>${trimmed}</span><br/>`;
      }
    }
  }

  if (inList) {
    html += '</ul>';
  }

  return html;
};

export const formatSafeDate = (dateStr, options = { day: '2-digit', month: 'short', year: 'numeric' }) => {
  if (!dateStr) return '-';
  const d = new Date(dateStr);
  if (isNaN(d.getTime())) return '-';
  return d.toLocaleDateString('en-GB', options);
};
